var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "favicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Favicon-&-logo",
    transform: "translate(-70, -70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "favicon",
    transform: "translate(70, 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#040802",
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    rx: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.419849,649.410836 L707.419849,376.370284 C707.419849,344.403488 681.426728,318.48928 649.36259,318.48928 C617.298451,318.48928 591.305331,344.403488 591.305331,376.370284 L591.305331,649.410836 C591.157738,668.828602 588.524801,688.148183 583.470343,706.90128 C571.618671,749.826893 546.708956,788.033188 512.171955,816.258102 C473.956023,848.488793 425.304638,865.794686 375.255544,864.960944 C278.158921,864.724985 193.074578,800.119943 167.040746,706.862224 C161.520897,688.201403 158.814359,668.826143 159.009883,649.37178 L159.009883,376.370284 C158.868314,356.66287 161.573005,337.037758 167.040746,318.09872 C193.339995,225.020658 278.262103,160.538801 375.255544,160 L375.255544,318.09872 C343.352659,318.692113 317.754661,344.559141 317.590035,376.370284 L317.590035,649.410836 C317.590035,681.161931 343.407763,706.90128 375.255544,706.90128 C407.103326,706.90128 432.921054,681.161931 432.921054,649.410836 L432.921054,376.370284 C433.103447,356.697994 435.735244,337.1244 440.756042,318.09872 C452.918614,275.530404 477.76961,237.652005 512.015255,209.483962 C535.528231,190.709885 562.448769,176.627466 591.305331,168.006482 C610.103237,162.883289 629.484146,160.192376 648.97084,160 C746.144059,160.518199 831.303683,224.937995 857.969138,318.09872 C863.056055,337.1161 865.753665,356.68983 866,376.370284 L866,649.410836 C865.807038,668.838371 863.107931,688.160441 857.969138,706.90128 C831.578505,800.249061 746.250756,864.796036 648.97084,865 L648.97084,706.90128 C680.878852,706.737153 706.824649,681.216868 707.419849,649.410836 L707.419849,649.410836 Z",
    id: "Path",
    fill: "#BFE82D",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLogo);
export default __webpack_public_path__ + "static/media/contactLogo.44d4bb77c928c8f76d2ad3480d1c3d5d.svg";
export { ForwardRef as ReactComponent };